import React, { useContext, useState } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Info, MopedOutlined, ReceiptLong, TrendingUp } from '@mui/icons-material';
import { OrgSettingsContext } from '../../../../../contexts/org-settings-context';
import { Button, Chip, Tooltip } from '@mui/material';
import { motion } from 'framer-motion';
import ImportanceBar from '../importance-bar';
import Decimal from 'decimal.js';
import { displayMoney } from '../../../../../utils/money';
import { IconWithText } from '../../../../common/styles/components';

interface DriversNodeProps {
  data: any;
}
export const DriversNode = ({ data }: DriversNodeProps) => {
  const { color } = useContext(OrgSettingsContext);
  const isAggregate = data?.isAggregate;
  const expanded = data?.expanded;

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      transition={{ duration: 0.3 }}
      style={{
        background: 'rgba(255, 255, 255, 0.75)',

        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        border: '1px solid #e0f2f1',
        borderRadius: '16px',
        padding: '20px',
        width: 260,
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
        fontFamily: `'Inter', 'Helvetica Neue', sans-serif`,
        color: '#333',
        position: 'relative',
      }}
    >
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
        <div
          style={{
            background: '#e3f2fd',
            borderRadius: '8px',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 10,
          }}
        >
          <MopedOutlined style={{ fontSize: 22, color: '#1976d2' }} />
        </div>
        <div style={{ fontSize: '1rem', fontWeight: 600 }}>
          {isAggregate ? 'Delivery Drivers' : data.label}
        </div>
      </div>



      


        
    <>
       <div style={{ marginTop: 4 }}>
         <IconWithText><Tooltip componentsProps={{
              tooltip: {
                sx: {
                  fontSize: '1rem',         // increase font size
                  padding: '10px 14px',     // add padding
                  backgroundColor: '#333',  // darker background
                  color: 'white',           // white text
                  borderRadius: 1,
                  boxShadow: 3              // subtle shadow
                }
              }
            }}  
            title="Total contribution to the profit.">
              <TrendingUp fontSize="small" color="success" />
              </Tooltip> {displayMoney(data.profit)}</IconWithText> 
         
        {!isAggregate && <ImportanceBar importance={data.profitImportance} color='green' />}
      </div>

      <div style={{ marginTop: 4}}>

           <IconWithText>
            <Tooltip componentsProps={{
              tooltip: {
                sx: {
                  fontSize: '1rem',         // increase font size
                  padding: '10px 14px',     // add padding
                  backgroundColor: '#333',  // darker background
                  color: 'white',           // white text
                  borderRadius: 1,
                  boxShadow: 3              // subtle shadow
                }
              }
            }}  
            title="Total cash paid to the delivery company.">
              <ReceiptLong fontSize="small" color="primary"  /></Tooltip> {isAggregate ? displayMoney(data.total) : displayMoney(data.amount)}</IconWithText> 
        {!isAggregate && <ImportanceBar importance={data.importance} color='orange'/>}
      </div>
      </>

      {isAggregate && data?.onToggleExpand && (
        <Button
          variant="outlined"
          onClick={data.onToggleExpand}
          size="small"
          sx={{ mt: 2 }}
        >
          {expanded ? 'Collapse' : 'See More'}
        </Button>
      )}
        
      <Handle
        type="source"
        position={Position.Left}
        id="source"
        style={{ opacity: 0 }}
      />

      <Handle
        type="target"
        position={Position.Right}
        id="sink"
        style={{ opacity: 0 }}
      />
    </motion.div>
  );
};
